module.exports = __webpack_public_path__ + "3b6baa974edfefcb1345269f97fcac23.pdf";